/** @typedef {String} PathifiedSvgContent */
/** @typedef {String} FeatherIconsPathDefinition */
/** @typedef {{ prefix: 'fe', iconName: 'feToggleRight', icon: [Number|String, Number|String, import('feather-icons').FeatherAttributes, PathifiedSvgContent, FeatherIconsPathDefinition] }} FeatherToggleRightIconData */

/** @type {FeatherToggleRightIconData} */
const feToggleRight = {
  prefix: 'fe',
  iconName: 'toggle-right',
  icon: [
    24,
    24,
    '<rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="16" cy="12" r="3"></circle>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-toggle-right"><path d="M8 5 H16 A7 7 0 0 1 23 12 V12 A7 7 0 0 1 16 19 H8 A7 7 0 0 1 1 12 V12 A7 7 0 0 1 8 5 z"/><path d="M19 12 A3 3 0 0 1 16 15 A3 3 0 0 1 13 12 A3 3 0 0 1 19 12 z"/></svg>',
    'M8 5 H16 A7 7 0 0 1 23 12 V12 A7 7 0 0 1 16 19 H8 A7 7 0 0 1 1 12 V12 A7 7 0 0 1 8 5 z M19 12 A3 3 0 0 1 16 15 A3 3 0 0 1 13 12 A3 3 0 0 1 19 12 z',
    '"xmlns"="http=//www.w3.org/2000/svg" "width"="24" "height"="24" "fill"="none" "stroke"="currentColor" "stroke-width"=2 "stroke-linecap"="round" "stroke-linejoin"="round"',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: 24,
      height: 24,
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': 2,
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
    },
  ],
}

export default feToggleRight
